import {getDataItem, kendoNumericFocus, kendoNumericMultiplierKeydown} from './kendo-helpers'

/* global kendo*/
const $ = kendo.jQuery

export function numericEditor(config, usesValidation, readOnly) {
  return function(container, options) {
    var editor = $(
      `<input ${(usesValidation && 'required ') || ''}
        ${readOnly ? 'disabled="disabled"' : ''}
        class="customNumericEditor"
        id="${options.field}"
        name="${options.field}"
        data-value-field="${options.field}"
        data-bind="value: ${options.field}"
        />`,
    )

    editor
      .appendTo(container)
      .kendoNumericTextBox(config)
      .focus(kendoNumericFocus)
      .keydown(kendoNumericMultiplierKeydown)
  }
}

export function jsonDropDownEditor(valueField, textField, url, additionalOptions, usesValidation) {
  return function(container, options) {
    const defaultOptions = {
      template: '<span>${' + textField + '}</span>',
      change: function(e) {
        const text = e.sender.text().trim(),
          value = e.sender.value(),
          dataItem = getDataItem(e.sender.element)

        dataItem.set(valueField, value)
        if (text != '') {
          dataItem.set(textField, text)
        }
      },
      dataSource: {
        transport: {
          read: {
            url: url,
            contentType: 'application/json',
            type: 'GET',
          },
        },
      },
    }

    const input = `<input ${usesValidation ? 'required' : ''}
                      id="${options.field}"
                      name="${options.field}"
                      data-text-field="${textField}"
                      data-value-field="${valueField}"
                      data-bind="value: ${textField == valueField ? options.field : valueField}"
                      />`

    $(input)
      .appendTo(container)
      .kendoDropDownList({
        ...defaultOptions,
        ...additionalOptions,
      })

    if (usesValidation) {
      $(`<span class="k-invalid-msg" data-for="${options.field}"></span>`).appendTo(container)
    }
  }
}

export function kendoMultiSelect(
  valueField,
  textField,
  url,
  additionalOptions,
  required,
  readOnly,
) {
  return function(container, options) {
    var defaultOptions = {
      dataTextField: textField,
      dataValueField: valueField,
      dataSource: {
        transport: {
          read: {
            url: url,
            contentType: 'application/json',
            type: 'GET',
            cache: false,
          },
        },
      },
      autoClose: false,
      change: function(e) {
        var dataItem = getDataItem(e.sender.element),
          multiselect = e.sender,
          selectedValue = multiselect.value()

        if (selectedValue.indexOf(0) >= 0) {
          var items = multiselect.dataSource.view().filter(function(element) {
            return element[valueField] != 0
          })

          var values = items.map(function(el) {
            return el[valueField]
          })
          multiselect.value(values)

          dataItem.set(options.field, items)
          this.close()
        }
      },
    }

    var input =
      '<select ' +
      (required && 'required ') +
      (readOnly && 'disabled="disabled" ') +
      ' id="' +
      options.field +
      '" name="' +
      options.field +
      '" multiple="multiple" data-bind="value:' +
      options.field +
      '" class = "custom-kendoMultiSelectWrapper"/>'

    $(input)
      .appendTo(container)
      .kendoMultiSelect($.extend(defaultOptions, additionalOptions))

    if (required) {
      $('<span class="k-invalid-msg" data-for="' + options.field + '" ></span>').appendTo(container)
    }
  }
}

export function createCheckboxColumn(gridElement, field, additionalOptions, disabled, noSync) {
  var uniqueId = field + '_' + (Math.floor(Math.random() * 250) + 8)
  var options = {
    field: field,
    headerAttributes: {
      style:
        'overflow:visible; white-space: normal; text-align: center; font-size:12px; vertical-align:middle;',
    },
    attributes: {
      style: 'text-align: center;',
    },
    editor: disabled
      ? "<input type='checkbox' data-bind='checked: " +
        field +
        "' #= " +
        field +
        " ? checked : '' # disabled />"
      : "<input type='checkbox' data-bind='checked: " +
        field +
        "' #= " +
        field +
        " ? checked : '' #/>",
    template: function(dataItem) {
      var value = dataItem[field] || false
      var valueTemplate = ''
      if (value) valueTemplate = "checked='checked'"
      var checkbox = disabled
        ? "<input id='" +
          uniqueId +
          "' class='" +
          uniqueId +
          "' type='checkbox' " +
          valueTemplate +
          " disabled='disabled' />"
        : "<input id='" +
          uniqueId +
          "' class='" +
          uniqueId +
          "' type='checkbox' " +
          valueTemplate +
          ' />'
      return checkbox
    },
  }

  $.extend(options, additionalOptions)

  $(gridElement).on('click', '.' + uniqueId, function() {
    var grid = $(gridElement).data('kendoGrid')
    var isChecked = this.checked,
      row = $(this).closest('tr'),
      dataItem = grid.dataItem(row)
    dataItem.set(field, isChecked)
    if (noSync == null) {
      grid.dataSource.sync()
    }
  })

  return options
}

export function readOnlyEditor(container, options) {
  function getFormattedValue() {
    var formatMatch = (options.format || '').match(/{0:(.*)}/),
      format = (formatMatch && formatMatch[1]) || '',
      value = options.model[options.field],
      text = kendo.toString(value, format)
    return text || ''
  }
  var element = $('<span></span>').text(getFormattedValue())

  options.model.bind('change', function(e) {
    if (e.field == options.field) {
      element.text(getFormattedValue())
    }
  })
  element.appendTo(container)
}

export function datePickerEditor(config, usesValidation, readOnly) {
  return function(container, options) {
    var editor = $(
      `<input class="${options.field}" name="${options.field}" data-bind="value:${options.field}"
        ${(usesValidation && 'required ') || ''}
        ${readOnly ? 'disabled="disabled"' : ''}
       />`,
    )
    editor.appendTo(container).kendoDatePicker(config)
  }
}

export function dateTimePickerEditor(config, usesValidation, readOnly) {
  return function(container, options) {
    var editor = $(
      `<input class="${options.field}" name="${options.field}" data-bind="value:${options.field}"
        ${(usesValidation && 'required ') || ''}
        ${readOnly ? 'disabled="disabled"' : ''}

       />`,
    )
    editor.appendTo(container).kendoDateTimePicker(config)
  }
}

export function checkboxColumn(field, additionalOptions, disabled, noSync, disabledByRow) {
  var uniqueId = field + '_' + (Math.floor(Math.random() * 250) + 8)
  var options = {
    field: field,
    headerAttributes: {
      style:
        'overflow:visible; white-space: normal; text-align: center; font-size:12px; vertical-align:middle;',
    },
    attributes: {
      style: 'text-align: center;',
    },
    editor: function(container, options) {
      const isDisabledByRow = typeof disabledByRow == 'function' && disabledByRow(options.model)
      const isDisabled = disabled || isDisabledByRow
      $(
        `<input type="checkbox" data-bind="checked: ${field}" ${isDisabled ? 'disabled' : ''} />`,
      ).appendTo(container)
    },
    template: function(dataItem) {
      if (typeof additionalOptions.customTemplate == 'function') {
        const customTemplate = additionalOptions.customTemplate(dataItem)
        if (customTemplate != null) {
          return customTemplate
        }
      }
      if (typeof disabledByRow == 'function' && disabledByRow(dataItem)) {
        return `<input type="checkbox" ${dataItem[field] ? 'checked' : ''} disabled />`
      }

      const value = dataItem[field] || false
      return `<input class="${uniqueId}"
                     type="checkbox"
                     ${value ? "checked='checked'" : ''}
                     ${disabled ? 'disabled="disabled"' : ''}/>`
    },
  }

  $.extend(options, additionalOptions)

  setTimeout(() => {
    $('.k-grid').on('click', '.' + uniqueId, function(e) {
      const isChecked = this.checked,
        dataItem = getDataItem(this)

      const grid = $(e.target)
        .closest('.k-grid')
        .getKendoGrid()

      dataItem.set(field, isChecked)
      if (noSync == null) {
        grid.dataSource.sync()
      }
    })
  }, 0)

  return options
}

export function radioButtonColumn(field, additionalOptions, disabled, noSync) {
  var uniqueId = field + '_' + (Math.floor(Math.random() * 250) + 8)
  var options = {
    field: field,
    headerAttributes: {
      style:
        'overflow:visible; white-space: normal; text-align: center; font-size:12px; vertical-align:middle;',
    },
    attributes: {
      style: 'text-align: center;',
    },
    editor: disabled
      ? "<input type='checkbox' data-bind='checked: " +
        field +
        "' #= " +
        field +
        " ? checked : '' # disabled />"
      : "<input type='checkbox' data-bind='checked: " +
        field +
        "' #= " +
        field +
        " ? checked : '' #/>",
    template: function(dataItem) {
      var value = dataItem[field] || false
      var valueTemplate = ''
      if (value) valueTemplate = "checked='checked'"
      var radio = disabled
        ? "<input id='" +
          uniqueId +
          "' class='" +
          uniqueId +
          "' type='radio' " +
          valueTemplate +
          " disabled='disabled' />"
        : "<input id='" +
          uniqueId +
          "' class='" +
          uniqueId +
          "' type='radio' " +
          valueTemplate +
          ' />'
      return radio
    },
  }

  $.extend(options, additionalOptions)

  setTimeout(() => {
    $('.k-grid').on('click', '.' + uniqueId, function(e) {
      const grid = $(e.target)
        .closest('.k-grid')
        .getKendoGrid()

      var isChecked = this.checked,
        row = $(this).closest('tr'),
        dataItem = grid.dataItem(row)
      dataItem.set(field, isChecked)
      if (noSync == null) {
        grid.dataSource.sync()
      }
    })
  }, 0)

  return options
}

export function readOnlyIf(condition, editor) {
  return function(container, options) {
    if (condition(options.model)) {
      return readOnlyEditor.call(this, container, options)
    }

    return editor.call(this, container, options)
  }
}
